import { ROUTE_PATH } from './consts';

export const createBrandEditPageUrl = brandId =>
  ROUTE_PATH.replace(':brandId', brandId);
